// src/components/Services.jsx

import React from 'react';

const TechScalability = () => {
  return (
    <div>
      <h2 className="text-4xl font-bold text-black mb-5">
   Technology Infrastructure And<span className="text-[#680099] ml-2 font-bold">Scalability</span>
</h2>

      {/* Container for the two boxes */}
      <div style={boxesContainerStyle}>
        {/* Left box */}
        <div style={leftBoxStyle}>
          <div style={boxHeadingStyle}>Component</div>
          <p style={boxContentStyle}> Custom Web Portal</p>
          <p style={leftboxContentStyle}> API Integration</p>
          <p style={leftboxContentStyle}> Compliance</p>
        </div>

        {/* middle box */}
        <div style={midBoxStyle}>
          <div style={boxHeadingStyle}>Description</div>
          <p style={boxContentStyle}> Built In-House With Tailored, Scalable Features</p>
          <p style={boxContentStyle}> Strategic Partners API For Real-Time Rate Fetching And Booking Confirmation</p>
          <p style={boxContentStyle}> Advanced Encryption And Regulatory Compliance, With Routine Security Audits</p>
        </div>

        {/* Right box */}
        <div style={rightBoxStyle}>
          <div style={boxHeadingStyle}>Benefits</div>
          <p style={boxContentStyle}>Complete Control Over Updates </p>
          <p style={rightboxContentStyle}>Enhanced Agent and Consumer Expereince</p>
          <p style={rightboxContentStyle}>Ensures Client Data Privacy</p>
        </div>
      </div>

      <h5 className="text-xl font-bold text-black mt-7 mb-1"> Scalability Potential</h5>
      {/* Bullet points list for Identified Market Gaps */}
      <ul style={bulletPointsStyle}>
        <li style={bulletPointItemStyle}> <strong>Agent Capacity: </strong> Supports over 500 agents, allowing rapid scaling without proportional cost increases.</li>
        <li style={bulletPointItemStyle}> <strong>Product Flexibility: </strong> Modular design enables future integrations (e.g. flights, acitivities) with minimal platform rebuilding. </li>
      </ul>

      
    </div>
  );
};

const bulletPointsStyle = {
    listStyleType: 'disc',  // Bullet points (disc)
    paddingLeft: '20px',    // Indentation for the list
    marginTop: '20px',      // Space above the list
  };
  
  const bulletPointItemStyle = {
    fontSize: '18px',       // Font size for the bullet point text
    marginBottom: '10px',   // Space between each bullet point
    lineHeight: '1.6',      // Line height for readability
  };

const boxesContainerStyle = {
  display: 'flex',  // Align items side by side
  gap: '20px',  // Space between the boxes
  marginTop: '19px',  // Optional: space between heading and boxes

};

const leftBoxStyle = {
  flex: 1,  // Takes up available space, but narrower due to specific width
  maxWidth: '25%',  // Adjust width to make it narrower
  backgroundColor: '#fbf4ff',  // Background color for the box
  borderRadius: '30px',
  padding: '0px',
};

const midBoxStyle = {
  flex: 1,  // Takes up available space, but narrower due to specific width
  maxWidth: '50%',  // Adjust width to make it narrower
  backgroundColor: '#fbf4ff',  // Background color for the box
  borderRadius: '30px',
  padding: '0px',
};

const rightBoxStyle = {
  flex: 1,  // Takes up available space
  backgroundColor: '#fbf4ff',  // Background color for the box
  borderRadius: '30px',
  padding: '0px',
  maxWidth: '25%',  // Adjust width to make it narrower

};

const boxHeadingStyle = {
  backgroundColor: '#321e5d',  // Background color for the heading
  color: 'white',
  padding: '10px',
  borderRadius: '30px 30px 0px 0px',   
  fontSize: '18px',
  fontWeight: 'bold',  
  textAlign: 'center',

  
};

const boxContentStyle = {
  
  textAlign: 'center',
  marginTop: '20px',
  fontSize: '18px',
  marginBottom: '40px'

};


const leftboxContentStyle = {
  
  textAlign: 'center',
   marginTop: '20px',
  fontSize: '18px',
  marginBottom: '60px'
};

const rightboxContentStyle = {
  
  textAlign: 'center',
  marginTop: '20px',
  fontSize: '18px',
  marginBottom: '40px'
};


export default TechScalability;
